import type { AudioWithChapters } from "@brookbush/types";

import useSWR from "swr";

import fetcher from "~/utils/fetcher.client";

const useCourseAudio = (courseSlug: string) => {
	const {
		data: courseAudio,
		isLoading: isLoadingCourseAudio,
		mutate,
	} = useSWR<AudioWithChapters | null>(`/courses/${courseSlug}/audio`, {
		errorRetryCount: 0,
	});

	const handleUpdateCurrentTimestamp = async (currentTimestamp: number) => {
		mutate(
			await fetcher(`/courses/${courseSlug}/audio`, {
				method: "PATCH",
				data: {
					currentTimestamp,
				},
			}),
			{
				revalidate: true,
				populateCache: false,
			},
		);
	};

	return { courseAudio, isLoadingCourseAudio, handleUpdateCurrentTimestamp };
};

export default useCourseAudio;
